import './style.scss';

export function our_values_block() {
  const block = document.querySelector('.our_values_block');
  if (!block) return;
  
}
